import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { ProjectsEditorService, ProjectsService } from '@app/services/app/projects.service';
import { VersionsService, VersionsViewService } from '@app/services/app/versions.service';

import * as Objects from '@core/objects';
import { TitleService } from '@core/services/title.service';
import { ActivatedRoute } from '@angular/router';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { AppService } from '@app/services/app/app.service';
import { AppRouterService } from '@app/services/app/router.service';
import { AddProjectService } from '@app/services/app/add-project.service';
import { LibraryService } from '@app/services/app/library.service';
// models
import { AccessVersion, AccessVersionStatus } from '@app/models/access';
import * as fromFeedbacksModel from '@core/models/version-feedback';
import * as fromState from '@app/store/state/versions/versions.state';
@Component({
    selector: 'project-version-details-main',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class ProjectDetailsVersionDetailsComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_ERROR = 2;
    public readonly STATUS_NOT_LINKED = 3;
    public readonly STATUS_NOT_FOUND= 4;
    public readonly STATUS_NOT_ACCESS_DONE= 5;

    public readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
    public readonly PLUGIN_SEND_FILES = 'share_transfer';
    public readonly ACCESS_UPLOAD_VERSION = "access_request_upload_version";
    public readonly ACCESS_SELF_FEEDBACK =  'access_request_add_my_feedback';
    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";
    public readonly ACCESS_EDIT_TAGS =  'access_version_edit_labels';
    public readonly ACCESS_CHANGE_STATUS =  'access_version_change_status';

    // for view reminder    
    public readonly VIEW_MODAL_NONE = 0;
    public readonly VIEW_APPROVAL_REMINDER_DONE = 1;
    public readonly VIEW_APPROVAL_REMINDER_ERROR = 2;
    public readonly VIEW_SELF_FEEDBACK_ERROR = 3;
    public readonly VIEW_SELF_FEEDBACK_DONE = 4;

    // feedback types
    public readonly FEEDBACK_TYPE_APPROVAL = 'approval';
    public readonly FEEDBACK_TYPE_COMMENTS = 'feedback';

    public version: Objects.Version = null;
    public project: Objects.Request = null;
    public user: Objects.User = null;
    public originProject: Objects.Request = null;
    public bcTitle: string = 'ARTWORK v. . . . <small>(# .  .  . )</small>';

    public excludedLabels: Array<Objects.Label> = [];

    public pluginsAccess: Array<string> = [];
    public versionAccess: AccessVersion = null;
    public uploadVersionAccess: boolean = false;
    public selfFeedbackAccess: boolean = false;
    public addProjectAccess: boolean = false;
    public selfFeedbackRequested: boolean = true; // by deafult we don't add self feedba buttons to 3dot menu
    public context: string = '';
    public modalView: number = this.VIEW_MODAL_NONE;

    public breadcrumbs: any = [];
    public menu: Array<ThreeDotsMenuItem> = [];
    // optional menu items
    protected menuUploadVersion: ThreeDotsMenuItem = {
        title: "Upload Artwork",
        key: "upload-artwork",
        icon: "upload_artwork",
        order: 1
    };
    protected menuSendFiles: ThreeDotsMenuItem = {
        title: "Send",
        key: "send-files",
        icon: "send-files",
        order: 2
    };
    protected menuRequestFeedback: ThreeDotsMenuItem = {
        title: "Request Feedback",
        key: "feedback",
        icon: "feedback",
        order: 3
    };
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 4
    };
    protected menuSeeOriginalProject: ThreeDotsMenuItem = {
        title: "See Original Project",
        key: "see-project",
        icon: "see-project",
        order: 5
    };
    protected menuReminder: ThreeDotsMenuItem = {
        title: "Send approval reminder",
        key: "send-reminder",
        icon: "approval-reminder",
        order: 6
    };
    protected menuRequestMyFeedback: ThreeDotsMenuItem = {
        title: "Add my comments",
        key: "add-my-comments",
        icon: "add-self-comments",
        order: 7
    };
    protected menuRequestMyApproval: ThreeDotsMenuItem = {
        title: "Add my approval",
        key: "add-my-approval",
        icon: "add-self-approval",
        order: 8
    };



    public status:number = this.STATUS_LOADING;

    protected urlSubscriptor: Subscription;
    protected urlqSubscriptor: Subscription;
    protected projectSubscriptor: Subscription;
    protected versionSubscriptor: Subscription;
    protected originProjectSubscriptor: Subscription;
    protected accessProjectSubscriptor: Subscription;
    protected accessMyFeedbackProjectSubscriptor: Subscription;
    protected accessVersionSubscriptor: Subscription;
    protected errorSubscriptor: Subscription;
    protected feedbacksSubscriptor:Subscription;
    protected sFbkReqActionStatusSubs: Subscription;


    constructor(
        public app: AppService,
        private librarySrv: LibraryService,
        private title: TitleService,
        private activeRoute: ActivatedRoute,
        private projectsSrv: ProjectsService,
        private viewVersionsSrv: VersionsViewService,
        private projectEditorSrv: ProjectsEditorService,
        private AddProjectSrv: AddProjectService,
        private versionsSrv: VersionsService,
        private appRouter: AppRouterService
    ) { }

    ngOnInit() {
        // HERE LOAD version status Access on Library Store. 
        // this.librarySrv.loadVersionsStatusAccess();
        this.setDefaultBredcrumb();
        // set temporal header title
        this.title.set("Artwork... - Project...");
        // TE QUIERO RIDE COMO A MI BIKE - CHICKEN TERIYAKI
        this.urlqSubscriptor = this.activeRoute.queryParams.subscribe((params: any) => {
            console.log("query params ===>", params);
            if (params.context) {
                this.context = params.context;
            }
        });

        this.projectSubscriptor = this.projectsSrv.selectProject().subscribe((project: Objects.Request) => {
            this.project = project;
            this.projectEditorSrv.loadSingleAccess(this.project.id);
            this.initView();
        });

        this.versionSubscriptor = this.viewVersionsSrv.selectVersion().subscribe((version: Objects.Version) =>
        {
            this.version = version;
            if(version != null){
                this.bcTitle = 'ARTWORK v.'+ version.version+' <small>(#'+ version.id+')</small>';
                this.getVersionAccess();
            }
            this.initView();
        });

        this.originProjectSubscriptor = this.viewVersionsSrv.selectProject().subscribe((projectOrigin: Objects.Request) => {
            this.originProject = projectOrigin
            this.initView();
        });

        this.urlSubscriptor = this.activeRoute.params.subscribe((params: any) => {
            // console.log(" params ", params);
            this.viewVersionsSrv.load(+params.vid);

        });
        // subscribe to upload version access
        this.accessProjectSubscriptor = this.projectEditorSrv.selectAccess(this.ACCESS_UPLOAD_VERSION).subscribe((access: boolean) => {
            this.uploadVersionAccess = access;
            this.updateMenu(this.menuUploadVersion,this.uploadVersionAccess);
        });
        this.accessMyFeedbackProjectSubscriptor = this.projectEditorSrv.selectAccess(this.ACCESS_SELF_FEEDBACK).subscribe((access: boolean) => {
            this.selfFeedbackAccess = access;
            this.updateSelfShareFeedbackMenus();
        });


        // plugins & add project from session
        this.app.getSession().subscribe( (session: any) => {
            this.pluginsAccess = session.options.plugins;
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;
            this.user = session.current.user;
            this.updateMenu(this.menuSendFiles,this.checkPluginAccess(this.PLUGIN_SEND_FILES));
            this.updateMenu(this.menuRequestFeedback,this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
            this.updateMenu(this.menuAddProject,this.addProjectAccess);
            if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){

                this.feedbacksSubscriptor = this.viewVersionsSrv.selectFeedbacks().subscribe((feedbacks: Array<fromFeedbacksModel.VersionFeedback>) => {
                    if(feedbacks != null && feedbacks.some((f:fromFeedbacksModel.VersionFeedback) => (f.status != null && f.status.status_code == fromFeedbacksModel.FeedbackStatusCodeEnum.OPENED_CODE ))){
                        this.updateMenu(this.menuReminder,this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK));
                    } else {
                        this.updateMenu(this.menuReminder,false);
                    }
                    // check we have some feedback request for current user
                    if(feedbacks != null){
                        this.selfFeedbackRequested = feedbacks.some((f:fromFeedbacksModel.VersionFeedback) => (f.user.id === this.user.id ));
                    }
                    this.updateSelfShareFeedbackMenus();
                })
            }
        });

        this.errorSubscriptor = this.viewVersionsSrv.selectError('load_version').subscribe((error: HttpErrorResponse) => {
            this.setError(error)
        });

        // subscriber for self feedback action status in store
        this.sFbkReqActionStatusSubs = this.viewVersionsSrv.selectSelfShareRequestActionStatus().subscribe((statusSF: fromState.VersionsActionStatus) => {
            if(statusSF.success){
                this.modalView = this.VIEW_SELF_FEEDBACK_DONE;
            }
            if (statusSF.error != null){
                    this.modalView = this.VIEW_SELF_FEEDBACK_ERROR;
            }
        });
    }

    ngOnDestroy() {
        this.urlSubscriptor.unsubscribe();
        this.urlqSubscriptor.unsubscribe();
        this.projectSubscriptor.unsubscribe();
        this.versionSubscriptor.unsubscribe();
        this.originProjectSubscriptor.unsubscribe();
        this.accessProjectSubscriptor.unsubscribe();
        if(this.accessVersionSubscriptor)
            this.accessVersionSubscriptor.unsubscribe();
        this.errorSubscriptor.unsubscribe();
        if(this.feedbacksSubscriptor)
            this.feedbacksSubscriptor.unsubscribe();
        this.sFbkReqActionStatusSubs.unsubscribe();
        this.viewVersionsSrv.resetSelfShareRequestActionStatus();
        this.viewVersionsSrv.clear();
    }

    private initView() {
        if(this.project != null && this.version != null){
            if (!this.isRelated()){
                console.debug(" The Artwork opened is not related to this project");
                this.status = this.STATUS_NOT_LINKED;
                return;
            }
            this.updateBreadcrumbs();
            
        }

        if(this.versionAccess == null || this.project == null || this.version == null  || this.originProject == null)
            return;
        this.setHeaderTitle();
        if(this.originProject.id != this.project.id){
            this.updateMenu(this.menuSeeOriginalProject);
        }
        this.status = this.STATUS_DONE;
    }

    private getVersionAccess(){
        this.accessVersionSubscriptor = this.librarySrv.selectVersionStatusAccess(this.version.status.id).subscribe((AccessVS: AccessVersionStatus) => {
            if(AccessVS != null && AccessVS.access.grants && this.status != this.STATUS_NOT_ACCESS_DONE){
                this.versionAccess = AccessVS.access.grants;
                //   console.log(" version access ---->",this.versionAccess);
                this.initView();
            }
        });
    }

    private setHeaderTitle() {
        this.title.set("Artwork #"+ this.version.id + "- Project #" + this.project.id);
    }

    onMenuClick(key: string) {
        switch(key) {
            case "upload-artwork":
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add', { queryParams: { links: this.version.labels.map((l: Objects.Label) => l.id).sort().join("-") } });
                break;
            case "add-project":
                if(this.version != null){
                    // clean new project store just in case
                    this.AddProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: this.version.id} });
                }
                break;
            case "see-project":
                this.appRouter.navigate('/projects/'+this.originProject.id);

                break;
            case "feedback":
                if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK))
                    this.appRouter.navigate('/p/feedback/'+this.project.id, { queryParams: { version: this.version.id} });
                break;
            case "send-files":
                if (this.checkPluginAccess(this.PLUGIN_SEND_FILES))
                    this.appRouter.navigate('/p/transfer/'+this.project.id, { queryParams: { version: this.version.id} });
                break;
            case "send-reminder":
                if (this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK))
                    this.versionsSrv.sendFeedbackReminder$([this.version]).subscribe(
                        (data:any) => {
                            console.debug(" REMINDER IS DONEEEE ", data)
                            this.modalView = this.VIEW_APPROVAL_REMINDER_DONE;
                        },
                        (error:any) => {
                            console.debug(" THIS REMINDER FAILED because DRAMA ", error)
                            this.modalView = this.VIEW_APPROVAL_REMINDER_ERROR;
                        }
                    );
                break;
            case "add-my-comments":
                if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
                    this.requestMyComments();
                }
                break;
            case "add-my-approval":
                if(this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
                    this.requestMyApprovalWithSign();
                }
                break;
        }
    }

    protected updateBreadcrumbs(){
        if(this.project == null)
            return;
        // PENDING IF THE CONTEXT IS FINALLY NECESSARY
        switch (this.context) {
            // case "origin":
                
            //     when came from origin no project breadcrumb all tags as excluded labels
            //     this.excludedLabels = this.version.labels;
            //     break;
            case "related":
            default:
                this.excludedLabels = this.project.labels;
                this.breadcrumbs[0] = {link: '/projects/'+this.project.id,
                                        title: 'Project <small>(#'+this.project.id+ ')</small>'};
                break;
        }
    }

    onStatusUpdate(status: Objects.Status) {
        this.viewVersionsSrv.setStatus(status);
    }

    onModalDismiss(e){
        this.modalView = this.VIEW_MODAL_NONE;
    }

    onSFModalDismiss(e){
        this.viewVersionsSrv.resetSelfShareRequestActionStatus();
        this.onModalDismiss(e);
    }

    protected checkPluginAccess(plugin: string){
        return this.pluginsAccess.some((pa) => pa == plugin);
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    // the common tags between project and version should be all of the project.
    protected isRelated(){
        let common = this.project.labels.filter((pl: Objects.Label) => this.version.labels.some((vl: Objects.Label) => vl.id == pl.id));
        if (common.length == this.project.labels.length)
            return true;
        return false;
    }


    protected setError(error: HttpErrorResponse) {
        // console.log("we have errors ",error)
        if(error == null)
            return;
        switch(error.status) {
            case 500:
                this.status = this.STATUS_ERROR;
                break;
            case 404:
                this.status = this.STATUS_NOT_FOUND;
                break;
            case 206:
                this.status = this.STATUS_NOT_ACCESS_DONE;
                break;
            case 200:
                this.status = this.STATUS_DONE;
                break;
        }
    }

    protected setDefaultBredcrumb(){
        this.breadcrumbs[0] = {link: '',
                            title: 'Project <small>( # . . . )</small>'};
    }

    protected updateSelfShareFeedbackMenus(){
        if(this.selfFeedbackAccess && this.checkPluginAccess(this.PLUGIN_REQUEST_FEEDBACK)){
            // we use the selfFeedbackRequested to update the menu. menu is there when user has NOT feedback requested
            this.updateMenu(this.menuRequestMyFeedback,!this.selfFeedbackRequested); 
            this.updateMenu(this.menuRequestMyApproval,!this.selfFeedbackRequested);
        }
    }

    protected requestMyComments(){
        let customData = { 
            type: "feedback",
            request: this.project.id, // added in dec-2024 <diego@twonas.com>
            get_approval: false,
            get_signature: false,
            get_comments: true, 
            allow_see: true,
        }
        this.onSubmitFeedbackRequest(customData);
    }

    protected requestMyApprovalWithSign(){
        let customData = { 
            type: "feedback",
            request: this.project.id, // added in dec-2024 <diego@twonas.com>
            get_approval: true,
            get_signature: true,
            get_comments: true, 
            allow_see: true,
        }
        this.onSubmitFeedbackRequest(customData);
    }

    protected onSubmitFeedbackRequest(optionsData: any) {
        let labels = this.project.labels.map(l => l.name).join(", ");
        // this.modalButtonDisabled = true;
        let typeFeedbackText = optionsData.get_approval ? 'approval' : 'feedback';
        const postData = {...optionsData,
            // Twona AMS - prefix already set on backend
            subject: this.user.name + " is requesting your "+typeFeedbackText+" on " + labels,
            message: "Please see files for you to review.",
            emails: [this.user.email]
        }
        // update menu 3 dot to remove self feedabck buttons.
        this.selfFeedbackRequested = true;
        this.updateSelfShareFeedbackMenus();
        this.viewVersionsSrv.sendSelfShareRequest(postData);
    }


}
